import { FormTypes } from 'shared-lib';

export const FormTypeMap: Record<string, FormTypes> = {
  Text: FormTypes.Text,
  'Text Description': FormTypes.TextDescription,
  Dropdown: FormTypes.Dropdown,
  Toggle: FormTypes.Bool,
  Number: FormTypes.Number,
  'Conditional Dropdown': FormTypes.ConditionalDropdown,
  'Date and Time': FormTypes.DateTime,
  Location: FormTypes.Location,
  // Alphanumeric: FormTypes.Alphanumeric,
  'Single Selection': FormTypes.SingleSelect,
  'Multiple Selection': FormTypes.MultiSelect,
  Scan: FormTypes.Scan,
  'File Upload': FormTypes.File,
  'Image Upload': FormTypes.Image
};

export const FormTypeLabelMap: Record<string, string> = {
  Text: 'Text',
  TextDescription: 'Text Description',
  Dropdown: 'Dropdown',
  Bool: 'Toggle',
  Number: 'Number',
  ConditionalDropdown: 'Conditional Dropdown',
  DateTime: 'Date and Time',
  Location: 'Location',
  Alphanumeric: 'Alphanumeric',
  SingleSelect: 'Single Selection',
  MultiSelect: 'Multiple Selection',
  Scan: 'Scan',
  File: 'File Upload',
  Image: 'Image Upload',
};
